<template>
    <Modal :mask-closable="true" v-model="show" :title="title" :width="width" class-name="QHcheckboxTree" @on-ok="ok()">
        <div class="QHTree" v-if="level == 2">
            <div class="one" v-for="(item1, index1) in tree" :key="index1">
                <h1>
                    <Checkbox :label="$FMT.toString(item1.id)" v-model="item1.ischeck" :disabled="true">{{ item1.name }}
                    </Checkbox>
                </h1>
                <div class="two" v-for="(item2, index2) in item1.children" :key="index2">
                    <Checkbox :label="$FMT.toString(item2.id)" v-model="item2.ischeck" :disabled="item2.isDisable == 1"
                        @on-change="changeCheckbox(index1, item1, item2)">{{ item2.name }}</Checkbox>
                </div>
            </div>
        </div>
    </Modal>
</template>




<script>
export default {
    // +----------------------------------------------------------------------
    // | Desc:data
    // +----------------------------------------------------------------------
    data() {
        return {
            show: false,
            valueTemp: [],
            tree: []
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:props
    // +----------------------------------------------------------------------
    props: {
        width: {
            type: [Number],
            default: 800
        },
        title: {
            type: String,
            default: "选择器"
        },
        level: {
            type: Number,
            default: 2
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:methods
    // +----------------------------------------------------------------------
    methods: {
        hiCheckboxTree(tree, value) {
            var tree = JSON.parse(JSON.stringify(tree));
            if (this.$isblank(value)) {
                this.valuetemp = [];
            } else {
                this.valuetemp = value.split(',');
            };
            this.tree = tree
            this.setCheckStatus(this.tree, this.valuetemp);
            this.show = true;
        },

        ok() {
            let data = this.valuetemp.join(',');
            this.$emit('change', data);
            console.log(1, this.valuetemp);
        },

        changeCheckbox(index1, item1, item2) {
            //子节点加入
            var id = this.$FMT.toString(item2.id);
            if (item2['ischeck']) {
                if (!this.valuetemp.includes(id)) {
                    this.valuetemp.push(id);
                };
            } else {
                if (this.valuetemp.includes(id)) {
                    this.valuetemp = this.$FMT.pull(this.valuetemp, id);
                };
            };

            //选中主节点
            var ischeck = item1['children'].some(item => item.ischeck == true);
            this.$set(this.tree[index1], 'ischeck', ischeck);

            //主要节点加入
            var id = this.$FMT.toString(item1.id);
            if (ischeck) {
                if (!this.valuetemp.includes(id)) {
                    this.valuetemp.push(id);
                };
            } else {
                if (this.valuetemp.includes(id)) {
                    this.valuetemp = this.$FMT.pull(this.valuetemp, id);
                };
            };
        },

        setCheckStatus(tree, allowedIds) {
            var self = this; // 保存Vue实例引用
            tree.forEach(function (node) {
                if (allowedIds.includes(self.$FMT.toString(node.id))) {
                    self.$set(node, 'ischeck', true);
                } else {
                    self.$set(node, 'ischeck', false);
                };
                // 如果有子节点，递归处理
                if (Array.isArray(node.children)) {
                    self.setCheckStatus(node.children, allowedIds);
                }
            });
        },

    }
}
</script>